import { createApp } from "vue";
import Search from "./Search.vue";
import { i18n } from '../../i18n';
// import store from "./store/store"; // Uncomment if you use Vuex store

if (document.querySelector('.search-container')) {
  const app = createApp(Search);
  // app.use(store); // Uncomment if you use Vuex store
  app.use(i18n);
  app.mount('.search-container');
}
